<script>
import Swal from "sweetalert2";
import SelectWithSearch from "../Common/SelectWithSearch.vue";
import { RAW_MATERIAL_PATH, VENDORS_PATH } from "@/path.js";
import axios from "axios";

export default {
  props: ["selectedOrder", "is_view"],
  data() {
    return {
      form: {},
      items: [],
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      key: 1,
      key2: 1,
    };
  },
  computed: {
    RAW_MATERIAL_PATH() {
      return RAW_MATERIAL_PATH;
    },
    VENDORS_PATH() {
      return VENDORS_PATH;
    },
  },
  watch: {
    "form.invoice_amount"(v) {
      if (!this.isEmpty(this.form.qty)) {
        this.form.unit_price = (v / this.form.qty).toFixed(4);
      }
    },
    "form.qty"(v) {
      if (!this.isEmpty(this.form.invoice_amount)) {
        this.form.unit_price = (this.form.invoice_amount / v).toFixed(4);
      }
    },
  },
  methods: {
    async getItems() {
      try {
        let res = await axios.get(
          this.baseUrl + RAW_MATERIAL_PATH.GET_ORDER_ITEMS,
          {
            params: {
              invoice_date: this.form.invoice_date,
              invoice_number: this.form.invoice_number,
              vendor: this.form.vendor,
              status: this.form.status,
              date_of_receiving: this.form.date_of_receiving,
            },
          }
        );
        if (res.data.status) {
          console.log("These are items", res.data.data);
          this.items = res.data.data.map((i) => {
            i.total_price = i.invoice_amount;
            return i;
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteItem(v) {
      try {
        let res = await axios.delete(
          this.baseUrl + RAW_MATERIAL_PATH.DELETE_ITEM,
          {
            id: v.id,
          }
        );
        if (res.data.status) {
          Swal.fire("Successfully deleted");
        }
      } catch (error) {
        console.log(error);
      }
    },
    setUnitPrice(i, v) {
      this.items[i].unit_price = v / this.items[i].qty;
      this.key2 += 1;
      console.log(this.items[i]);
    },
    selectedMaterial(i, v) {
      this.items[i].item_id = v;
    },
    addItems() {
      this.items.push({
        item_id: null,
      });
    },
    removeItems(i) {
      console.log(i);
      if (this.selectedOrder && Object.keys(this.selectedOrder).length > 0) {
        this.deleteItem(i);
      }
      this.items.splice(i, 1);
    },
    isEmpty(v) {
      if (v != null && v != "") {
        return false;
      }
      return true;
    },
    validate() {
      let res = true;
      Object.keys(this.form).forEach((k) => {
        console.log(this.form[k]);
        if (this.isEmpty(this.form[k])) {
          Swal.fire("Please fill all the fields", "", "error");
          console.log(k);
          res = false;
          return res;
        }
      });
      this.items.forEach((i) => {
        Object.keys(i).forEach((k) => {
          if (this.isEmpty(i[k])) {
            console.log(k);
            Swal.fire("Please Fill " + k + " Data");
            res = false;
          } else if (k == "batch_code") {
            // let d = [];
            // this.items.forEach((f) => {
            //   if (!d.includes(f[k])) {
            //     console.log(k);
            //     d.push(f[k]);
            //   } else {
            //     console.log(k);
            //     Swal.fire("Batch Code Cannot be duplicate");
            //     res = false;
            //   }
            // });
          }
        });
      });
      return res;
    },
    setVendor(v) {
      this.form.vendor = v;
      if (!this.selectedOrder) {
        this.getRawMaterials();
      }
    },
    async getRawMaterials() {
      try {
        console.log(this.form.vendor);
        let res = await axios.get(
          this.baseUrl + VENDORS_PATH.GET_VENDOR_RAW_MATERIALS,
          {
            params: {
              vendor_id: this.form.vendor,
            },
          }
        );
        if (res.data.status) {
          this.items = [];
          res.data.data.forEach((r) => {
            this.items.push({
              item_id: r.raw_material_id,
              qty: 0,
              uom: r.units == "kg" ? "Kgs" : "",
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveOrder() {
      if (!this.validate()) {
        return;
      }
      try {
        this.form.items = this.items;
        let res = await axios.post(
          this.baseUrl + RAW_MATERIAL_PATH.SAVE_ORDER,
          this.form
        );
        if (res.data.status) {
          this.$emit("reload");
          Swal.fire("Order Saved", "", "success");
        } else {
          console.log(res);
          Swal.fire(res.data.message);
        }
      } catch (error) {
        console.log(error);
        Swal.fire(error);
      }
    },
  },
  mounted() {
    console.log(this.selectedOrder);
    if (this.selectedOrder) {
      this.form.vendor = this.selectedOrder.vendor;
      this.form.invoice_number = this.selectedOrder.invoice_number;
      this.form.invoice_date = this.selectedOrder.invoice_date;
      this.form.date_of_receiving = this.selectedOrder.date_of_receiving;
      this.form.status = this.selectedOrder.status;
      this.key += 1;
      this.getItems();
    }
  },
  components: { SelectWithSearch },
};
</script>

<template>
  <div>
    <!-- <b-row>
            <b-col sm="12">
                <label>Item</label>
                <SelectWithSearch v-if="!is_view" :search_api="RAW_MATERIAL_PATH.SEARCH_ITEMS" :selected_data="[selectedOrder ? selectedOrder.raw_material.id : form.item_id]" selected_by="id" track_by="id" display="name" @selectedOption="selectedMaterial"></SelectWithSearch>
                <p v-else>{{ selectedOrder.raw_material.name  }}</p>
            </b-col> 
        </b-row> -->
    <b-row :key="key">
      <!-- <b-col sm="6">
                <label>Batch Code</label>
                <b-input :readonly="is_view ? true : false" v-model="form.batch_code"></b-input>
            </b-col> -->
      <b-col sm="6">
        <label>Vendor</label>
        <SelectWithSearch
          :search_api="VENDORS_PATH.GET"
          :selected_data="[parseInt(form.vendor)]"
          selected_by="id"
          extra_params="&no_pagination=true"
          display="name"
          track_by="id"
          @selectedOption="setVendor"
        ></SelectWithSearch>
      </b-col>
      <b-col sm="6">
        <label>invoice_number</label>
        <b-input
          :readonly="is_view ? true : false"
          v-model="form.invoice_number"
        ></b-input>
      </b-col>
      <b-col sm="6">
        <label>Invoice Date</label>
        <b-datepicker
          :readonly="is_view ? true : false"
          v-model="form.invoice_date"
        ></b-datepicker>
      </b-col>
      <b-col sm="6">
        <label>Date of receiving</label>
        <b-datepicker
          :readonly="is_view ? true : false"
          v-model="form.date_of_receiving"
        ></b-datepicker>
      </b-col>
      <!-- <b-col sm="6">
                <label>Best Before Date</label>
                <b-datepicker :readonly="is_view ? true : false" v-model="form.best_before_date"></b-datepicker>
            </b-col> -->
      <!-- <b-col sm="6">
                <label>Qty Expected</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.qty"></b-input>
            </b-col>
            <b-col sm="6">
                <label>Qty Received</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.qty_received"></b-input>
            </b-col> -->
      <!-- <b-col sm="6">
                <label>Total Amount (Rs)</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.invoice_amount"></b-input>
            </b-col> -->
      <!-- <b-col sm="6">
                <label>Pack Size</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.pack_size"></b-input>
            </b-col>
            <b-col sm="6">
                <label>Uom</label>
                <b-select :readonly="is_view ? true : false" :options="['Kgs','Box','Pcs','Tray','Ltr']" v-model="form.uom"></b-select>
            </b-col>
            <b-col sm="6">
                <label>Unit Price</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.unit_price"></b-input>
            </b-col>             -->
    </b-row>
    <b-button
      variant="primary"
      v-if="!is_view"
      @click="addItems"
      class="float-right"
      ><i class="fa fa-plus"></i> Add Line Item</b-button
    >
    <table class="table">
      <thead>
        <tr>
          <th style="width: 20%">Raw Material</th>
          <!-- <th>Batch Code</th> -->
          <th>Qty</th>
          <th>Uom</th>
          <th>Total Price</th>
          <th>Unit Price</th>
          <th v-if="!is_view">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(it, i) in items" :key="i">
          <td>
            <SelectWithSearch
              :key="items.length + i"
              v-if="!is_view"
              :search_api="RAW_MATERIAL_PATH.SEARCH_ITEMS"
              :selected_data="[it.item_id]"
              selected_by="id"
              track_by="id"
              display="name"
              @selectedOption="selectedMaterial(i, $event)"
            ></SelectWithSearch>
            <p v-if="is_view == true">{{ it.raw_material.name }}</p>
          </td>
          <!-- <td>
                        <b-input :readonly="is_view" v-model="it.batch_code"></b-input>
                    </td> -->
          <td>
            <b-input
              :readonly="is_view"
              type="number"
              v-model="it.qty"
            ></b-input>
          </td>
          <td>
            <b-select
              v-if="!is_view"
              :options="['Kgs', 'Box', 'Pcs', 'Tray', 'Ltr']"
              v-model="it.uom"
            ></b-select>
            <p v-if="is_view">{{ it.uom }}</p>
          </td>
          <td>
            <b-input
              :readonly="is_view"
              type="number"
              v-model="it.total_price"
              @change="setUnitPrice(i, $event)"
            ></b-input>
          </td>
          <td :key="key2 + i">
            <b-input
              :readonly="is_view"
              type="number"
              v-model="it.unit_price"
            ></b-input>
          </td>
          <td>
            <b-button v-if="!is_view" variant="danger" @click="removeItems(i)"
              ><i class="fa fa-trash"></i
            ></b-button>
          </td>
        </tr>
      </tbody>
    </table>
    <b-card-footer class="mt-4">
      <b-button variant="success" v-if="is_view == false" @click="saveOrder"
        >Save</b-button
      >
    </b-card-footer>
  </div>
</template>

<style></style>
